import React, { useContext } from 'react';
import { useSessions } from 'services/propertyFinderSessions';

const PropertyFinderSessionsContext = React.createContext(null);

export function PropertyFinderSessionsContextProvider({ children }) {
  const {
    data: sessions = [],
    isLoading: isSessionsLoading,
    refetch: reloadSessions,
    error: sessionsError
  } = useSessions();

  return (
    <PropertyFinderSessionsContext.Provider
      value={{
        sessions,
        isSessionsLoading,
        reloadSessions,
        sessionsError
      }}
    >
      {children}
    </PropertyFinderSessionsContext.Provider>
  );
}

export function usePropertyFinderSessions() {
  const context = useContext(PropertyFinderSessionsContext);

  if (!context) {
    throw new Error(
      'usePropertyFinderSessions must be used within a PropertyFinderSessionsContextProvider'
    );
  }

  return context;
}
